export { SignInPage as default } from '@modules/uaa';
